import { UserService } from './../../_services/user.service';
import { Component, EventEmitter, OnChanges, Output, SimpleChanges} from '@angular/core';
import { StepTypePopupComponent } from './step-type-popup.component';

@Component({
  moduleId: module.id.toString(),
  selector: 'step-subtype-popup',
  templateUrl: './step-subtype-popup.component.html',
  styleUrls: ['./../steps.component.scss'],
})
export class StepSubtypePopupComponent extends StepTypePopupComponent implements OnChanges {
  @Output('back') onBack: EventEmitter<any> = new EventEmitter<any>();
  constructor(protected userService: UserService) {
    super(userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.preselectFirstStep();
  }

  ngOnChanges(changes: SimpleChanges) {
    // When inputData changes, reset and pre-select the first non-disabled step
    if (changes.inputData && this.inputData && this.inputData.steps) {
      this.preselectFirstStep();
    }
  }

  private preselectFirstStep() {
    if (this.inputData && this.inputData.steps) {
      // Reset selection state for subtype popup
      this.selectedStepType = null;
      this.selectedIntent = null;
  
      // Pre-select first non-disabled step
      const firstEnabledStep = this.inputData.steps.find(step => !step.disabled);
      if (firstEnabledStep) {
        this.selectedStepType = firstEnabledStep.type;
        if (this.isSurvey) {
          this.selectedIntent = firstEnabledStep.offer_intent;
        }
      }
    }

  }

  // Override to emit only path without selectedType
  onNext() {
    if (this.selectedStepType) {
      const routes = this.getRouteConfig(this.selectedStepType, this.selectedIntent);
      const path = this.inputData.use_existing_template ? routes.template : routes.base;

      this.onSave.emit({ path });
    }
  }

  onBackClick() {
    this.onBack.emit();
  }
}
